import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Eyebrow, MaskLines, Reveal } from "@/components/site/Motion";

export default function About() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);
  const clip = useTransform(scrollYProgress, [0, 0.4], ["inset(18% 18% 18% 18% round 32px)", "inset(0% 0% 0% 0% round 32px)"]);

  return (
    <section id="societe" ref={ref} className="relative py-24 sm:py-36" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 grid lg:grid-cols-12 gap-14 items-center">
        <div className="lg:col-span-6 order-2 lg:order-1">
          <motion.div style={{ clipPath: clip }} className="relative aspect-[4/5] sm:aspect-[5/4] lg:aspect-[4/5] overflow-hidden bg-[#0c1222]">
            <motion.img
              src="/assets/squeegee.jpg"
              alt="Nettoyage de vitre à la raclette"
              style={{ y, scale: 1.25 }}
              className="absolute inset-0 h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-[#22a6ff]/20 mix-blend-color" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#050811]/80 to-transparent" />
          </motion.div>
        </div>

        <div className="lg:col-span-6 order-1 lg:order-2">
          <Eyebrow index="03">La société</Eyebrow>
          <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight text-white leading-[1.02]">
            <MaskLines inView lines={["Une entreprise jeune,", <span key="c" className="font-serif-i text-brand">une exigence entière.</span>]} />
          </h2>
          <Reveal delay={0.15}>
            <p className="mt-8 text-base sm:text-lg text-slate-300 leading-relaxed">
              UNDERCLEAN est une micro-entreprise de propreté et de services.
              Notre ambition est simple : offrir aux professionnels un nettoyage fiable, soigné et
              réellement attentif à ce qui ne se voit pas au premier regard.
            </p>
          </Reveal>
          <Reveal delay={0.25}>
            <p className="mt-5 text-base sm:text-lg text-slate-300 leading-relaxed">
              Être une structure à taille humaine, c'est avoir un interlocuteur direct, une vraie souplesse
              d'organisation et l'engagement personnel de celui qui intervient chez vous.
            </p>
          </Reveal>
          <Reveal delay={0.35}>
            <blockquote className="mt-10 border-l-2 border-cyan-300 pl-6 font-serif-i text-2xl sm:text-3xl text-white leading-snug">
              « Le propre, ce n'est pas ce qui brille. C'est ce qui dure. »
            </blockquote>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
